import React, { useEffect } from "react";
import { Button, ConfigProvider, Layout } from "antd"; // Import Button from Ant Design
import HomePage from "./pages/Home";
import LoginPage from "./pages/Login/LoginPage";
import SignupPage from "./pages/Signup/SignupPage";
import ResetPassPage from "./pages/ResetPassword/ResetPassPage";
import ForgotPasswordPage from "./pages/ForgotPassword/ForgotPasswordPage";
import "./App.css";
import Excel2Pdf from "./pages/Excel2Pdf";
import Dashboard from "./pages/Dashboard";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import WordToPdf from "./pages/Word2Pdf";
import Powerpoint2Pdf from "./pages/Powerpoint2Pdf";
import QRLink from "./pages/QRLink";
import DashboardHome from "./pages/DashboardHome";
import QRList from "./pages/QRList";
import QRText from "./pages/QRText";
import QRCreate from "./pages/QRCreate";
import QRPublic from "./pages/QRPublic";
import PdfList from "./pages/PdfList";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import PrivacyTerms from "./pages/PrivacyTerms";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Image2Pdf from "./pages/Image2Pdf";
import BlogList from './pages/Blogs/BlogList';
import BlogDetail from './pages/Blogs/BlogDetail';
import MergePdf from './pages/MergePdf';
import CompressPdf from './pages/CompressPdf';
import SplitPdf from './pages/SplitPdf';
import RearrangePdf from './pages/RearrangePdf';
import OcrPdf from './pages/OcrPdf';
import ESignPdf from './pages/ESignPdf';
import AddPasswordPdf from './pages/AddPasswordPdf';
import RemovePasswordPdf from './pages/RemovePasswordPdf';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#e5322d",
          colorBgLayout: "#ffffff",
        },
      }}
    >
      <Layout>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy_policy" element={<PrivacyTerms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/blogs" element={<BlogList />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/merge-pdf"        element={<MergePdf />} />
            <Route path="/compress-pdf"     element={<CompressPdf />} />
            <Route path="/split-pdf"        element={<SplitPdf />} />
            <Route path="/rearrange-pdf"    element={<RearrangePdf />} />
            <Route path="/ocr-pdf"          element={<OcrPdf />} />
            <Route path="/esign-pdf"        element={<ESignPdf />} />
            <Route path="/add-password"     element={<AddPasswordPdf />} />
            <Route path="/remove-password"  element={<RemovePasswordPdf />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<SignupPage />} />
            <Route path="/forgotpass" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPassPage />} />
            <Route path="/word2pdf" element={<WordToPdf />} />
            <Route path="/excel2pdf" element={<Excel2Pdf />} />
            <Route path="/ppt2pdf" element={<Powerpoint2Pdf />} />
            <Route path="/image2pdf" element={<Image2Pdf />} />
            <Route path="/qr-link" element={<QRLink />} />
            <Route path="/qr-text" element={<QRText />} />
            <Route path="/qr-location" element={<QRCreate qrType="Location" />} />
            <Route path="/qr-brand" element={<QRCreate qrType="Brand" />} />
            <Route path="/qr-social" element={<QRCreate qrType="Social" />} />
            <Route path="/qr-file" element={<QRCreate qrType="File" />} />
            <Route path="/qr-vcard" element={<QRCreate qrType="vCard" />} />
            <Route path="/qr-product" element={<QRCreate qrType="Product" />} />
            <Route path="/qr-message" element={<QRCreate qrType="Message" />} />
            <Route path="/qr/:uniqueId" element={<QRPublic />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<Dashboard />}>
                <Route path="home" element={<DashboardHome />} />
                <Route path="qr-link" element={<QRLink />} />
                <Route path="qr-text" element={<QRText />} />
                <Route path="qr-location" element={<QRCreate qrType="Location" />} />
                <Route path="qr-brand" element={<QRCreate qrType="Brand" />} />
                <Route path="qr-social" element={<QRCreate qrType="Social" />} />
                <Route path="qr-file" element={<QRCreate qrType="File" />} />
                <Route path="qr-vcard" element={<QRCreate qrType="vCard" />} />
                <Route path="qr-product" element={<QRCreate qrType="Product" />} />
                <Route path="qr-message" element={<QRCreate qrType="Message" />} />
                <Route path="qr-list" element={<QRList />} />
                <Route path="pdf-list" element={<PdfList />} />
                <Route path="word2pdf" element={<WordToPdf />} />
                <Route path="excel2pdf" element={<Excel2Pdf />} />
                <Route path="ppt2pdf" element={<Powerpoint2Pdf />} />
                <Route path="image2pdf" element={<Image2Pdf />} />
                <Route path="merge"         element={<MergePdf />} />
                <Route path="compress"      element={<CompressPdf />} />
                <Route path="split"         element={<SplitPdf />} />
                <Route path="rearrange"     element={<RearrangePdf />} />
                <Route path="ocr"           element={<OcrPdf />} />
                <Route path="esign"         element={<ESignPdf />} />
                <Route path="addpass"       element={<AddPasswordPdf />} />
                <Route path="removepass"    element={<RemovePasswordPdf />} />
              </Route>
            </Route>
          </Routes>
        </Router>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
